import React from 'react';

/**
 * A React element that renders a floating date header on the event card
 * @author Ryan McAvoy
 * @date 2023-11-29
 * @param {Object} startDate
 * @param {Object} endDate
 * @returns {ReactNode}
 */

const EventCardDateHeader = ({ startDate, endDate }) => {
  if (!startDate && !endDate) return;

  const start = new Date(startDate);
  const end = new Date(endDate);

  const monthNames = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

  const data = {
    start: {
      day: start?.getDate(),
      month: monthNames[start?.getMonth()],
    },
    end: {
      day: end?.getDate(),
      month: monthNames[end?.getMonth()],
    },
  };

  const DateElement = ({ day, month }) => {
    return (
      <div className="card-date">
        <div className="card-date__day">{day}</div>
        <div className="card-date__month">{month}</div>
      </div>
    );
  };

  return (
    <div className="event-cards__date_wrapper">
      {startDate && <DateElement day={data.start.day} month={data.start.month} />}
      {endDate && <DateElement day={data.end.day} month={data.end.month} />}
    </div>
  );
};
export default EventCardDateHeader;
